
.button {
  margin-right: 1em;
  font-size: 1rem;
}

.error {
  color: red;
}

.navigation {
  display: flex;
  justify-content: flex-end;
  padding-top: 1em;

  & > .navButton {
    margin-left: 1em;
  }
}

.navigationLastPage {
  justify-content: flex-start;
}

.surveyPartHeading {
  padding-top: 1em;
  padding-bottom: 0;
}

.requiredQuestionInfo {
  margin-bottom: 2em;
}
